import _ from 'lodash';
import { CUSTOM_ELEMENTS_SCHEMA, Component, DestroyRef, OnInit, inject } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { CoreModule } from 'app/core/core.module';
import { MdbAutocompleteModule } from 'mdb-angular-ui-kit/autocomplete';
import { CommonModule } from '@angular/common';
import { GoogleMapsAutocompleteModule } from 'app/google-maps-autocomplete/google-maps-autocomplete.module';
import { NgxCurrencyDirective } from 'ngx-currency';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { ToastService } from 'app/toast/services/toast.service';
import { ToastModule } from 'app/toast/toast.module';
import { AddVolunteerModalService } from 'app/volunteers/services/add-volunteer-modal/add-volunteer-modal.service';
import { VolunteerService } from 'app/volunteers/services/volunteer/volunteer.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  standalone: true,
  selector: 'app-add-volunteer',
  templateUrl: './add-volunteer.component.html',
  styleUrls: ['./add-volunteer.component.scss'],
  imports: [FormsModule,ReactiveFormsModule,MdbFormsModule,MdbSelectModule,CoreModule,CommonModule,ToastModule,MdbAutocompleteModule,GoogleMapsAutocompleteModule, NgxCurrencyDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AddVolunteerComponent implements OnInit {
    destroyRef = inject(DestroyRef)

    public form: FormGroup = new FormGroup({
        email: new FormControl("", [Validators.required, Validators.pattern(/^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/)])
    });

    public emailError: string = '';

    constructor(
        private addVolunteerModalService: AddVolunteerModalService,
        private volunteerService: VolunteerService,
        private toastService: ToastService
    ) {}

    ngOnInit(): void {
    }

    addVolunteer() {
        if(this.form.invalid) {
            return this.form.markAllAsTouched();
        };
        this.emailError = '';
        return this.volunteerService.add(this.form.value).pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe({
            next: () => {
                this.toastService.showSuccess("User added");
                return this.close(true);
            },
            error: (error) => {
                if (error?.errorCode === "UserAlreadyExist" && error?.debugInfo === "UserAlreadyExist") {
                    this.emailError = 'User is already a volunteer';
                } else {
                    this.toastService.showDanger("Failed to add volunteer");
                }
            }
        });
    }

    ngAfterViewInit(): void {
    }

    close(message = null) {
        this.addVolunteerModalService.close(message);
    }
}
